import { render, staticRenderFns } from "./TifInspeccionImages.vue?vue&type=template&id=2fe6479e"
import script from "./TifInspeccionImages.vue?vue&type=script&lang=js"
export * from "./TifInspeccionImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports